var Preloader = {

	start: function() {
	},
	
	progress: function(percent) {
		$("#preloader").html(percent + "%");
	}

}